import { http } from '@/lib/ats-https';
import { http as oldHttp } from '@/lib/http';

import { ReportByTypeApiResponse, ReportPayload } from '../types/api/apiTypes';
import { ReportNameType, ReportViewType } from '../types/reportConfigTypes';

const createCustomReport = async (payload) => {
  const response = await http.post('/reports/custom_reports/', payload);
  return response.data;
};

const getCustomReports = async () => {
  const response = await http.get('/reports/custom_reports/');
  return response.data;
};

const getCustomReport = async (reportID) => {
  const response = await http.get(`/reports/custom_reports/${reportID}`);
  return response;
};

const deleteCustomReport = async (reportID) => {
  const response = await http.delete(`/reports/custom_reports/${reportID}`);
  return response.data;
};

const cloneCustomReport = async (reportID, payload) => {
  const response = await http.post(
    `/reports/custom_reports/${reportID}/clone`,
    payload
  );
  return response.data;
};

const updateCustomReport = async (reportID, payload) => {
  const response = (await http.put(
    `/reports/custom_reports/${reportID}`,
    payload
  )) as any;

  if (response?.errors?.length) {
    return { error: response?.errors };
  }
  return response?.data;
};

const getTileData = async (url: string, payload: any, isNonAts: any) => {
  const currentHttp = isNonAts ? oldHttp : http;
  const response = await currentHttp.post(url, payload);
  return response.data;
};

const createCustomReportTiles = async (reportID, payload) => {
  const response = await http.post(
    `/reports/custom_reports/${reportID}/tiles/bulk`,
    payload
  );
  return response.data;
};

const deleteCustomReportTiles = async (reportID, payload) => {
  const response = await http.delete(
    `/reports/custom_reports/${reportID}/tiles/bulk`,
    payload
  );
  return response.data;
};

const getReportByType = async (
  reportName: ReportNameType,
  viewType: ReportViewType,
  payload: ReportPayload
): Promise<ReportByTypeApiResponse> => {
  const url = `/reports/${reportName}/${viewType}`;

  try {
    const response = await http.post<ReportByTypeApiResponse>(url, payload);
    return response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status other than 2xx
      throw new Error(
        `Failed to fetch ${viewType} data for ${reportName}: ${error.response.data.errors.join(
          ', '
        )}`
      );
    } else if (error.request) {
      // Request was made but no response received
      throw new Error(
        `No response received while fetching ${viewType} data for ${reportName}`
      );
    } else {
      // Something else happened while setting up the request
      throw new Error(
        `Error occurred while fetching ${viewType} data for ${reportName}: ${error.message}`
      );
    }
  }
};

const addTiles = async (reportID, payload) => {
  const response = await http.post(
    `/reports/custom_reports/${reportID}/tiles/bulk`,
    payload
  );
  return response.data;
};

const deleteTiles = async (reportID, payload) => {
  const response = await http.delete(
    `/reports/custom_reports/${reportID}/tiles/bulk`,
    { data: payload }
  );
  return response.data;
};

export const API_SERVICE = {
  createCustomReport,
  getCustomReports,
  getCustomReport,
  getReportByType,
  getTileData,
  deleteCustomReport,
  cloneCustomReport,
  updateCustomReport,
  createCustomReportTiles,
  deleteCustomReportTiles,
  addTiles,
  deleteTiles,
};
